module.exports = __webpack_public_path__ + "img/icon_sec6_04.2ae869f1.png";